import { transformGamesWithJoinedOdds } from '../../services/UserGroup.js';
import { APP_CONFIG } from '../constants/global-variables.js';
export async function getLiveGames(getSportValueId, market_type) {
    if (getSportValueId && getSportValueId != 1) market_type = 1;
    const options = {
        method: "GET"
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/livegames`;

    try {
        const res = await axios.post(url, {
            sport: getSportValueId,
            market_type: market_type,
        });

        const dataTransformed = transformGamesWithJoinedOdds(res.data);
        return dataTransformed;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}
